import React from 'react';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { WithPluginState } from '@atlaskit/editor-common/with-plugin-state';
import { fg } from '@atlaskit/platform-feature-flags';
import { aiButtonPluginKey } from '../../pm-plugins/ai-button/ai-button-plugin-key';
import { createOpenAIModalCommand } from '../../pm-plugins/decoration/actions';
import { AtlassianIntelligenceToolbarButton } from '../components/AtlassianIntelligenceToolbarButton/AtlassianIntelligenceToolbarButton';
var PrimaryToolbarLegacyComponent = function PrimaryToolbarLegacyComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    editorPluginAIProvider = _ref.editorPluginAIProvider,
    aiGlobalOptIn = _ref.aiGlobalOptIn;
  var aiButtonState = useSharedPluginStateSelector(api, 'aiExperience.aiButtonState');
  if (fg('platform_editor_ai_composable_editor_migration')) {
    var onClick = function onClick() {
      var state = editorView.state,
        dispatch = editorView.dispatch;
      var configItem = editorPluginAIProvider.baseGenerate;
      var openAIModalCommand = createOpenAIModalCommand({
        state: state,
        configItem: configItem,
        lastTriggeredFrom: 'mainToolbar',
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: aiButtonState === null || aiButtonState === void 0 ? void 0 : aiButtonState.triggeredFor
      });
      openAIModalCommand(state, dispatch);
    };
    return /*#__PURE__*/React.createElement(AtlassianIntelligenceToolbarButton, {
      ButtonWrapper: editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.AIButtonWrapper,
      onClick: onClick,
      disabled: !(aiButtonState !== null && aiButtonState !== void 0 && aiButtonState.isSelectionValidForAIExperience),
      view: editorView
    });
  } else {
    return /*#__PURE__*/React.createElement(WithPluginState, {
      plugins: {
        pluginState: aiButtonPluginKey
      },
      render: function render(_ref2) {
        var pluginState = _ref2.pluginState;
        var aiButtonPluginState = pluginState;
        var onClick = function onClick() {
          var state = editorView.state,
            dispatch = editorView.dispatch;
          var configItem = editorPluginAIProvider.baseGenerate;
          var openAIModalCommand = createOpenAIModalCommand({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: aiButtonPluginState.triggeredFor
          });
          openAIModalCommand(state, dispatch);
        };
        return /*#__PURE__*/React.createElement(AtlassianIntelligenceToolbarButton, {
          ButtonWrapper: editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.AIButtonWrapper,
          onClick: onClick,
          disabled: !(aiButtonPluginState !== null && aiButtonPluginState !== void 0 && aiButtonPluginState.isSelectionValidForAIExperience),
          view: editorView
        });
      }
    });
  }
};
export var getPrimaryToolbarLegacyComponent = function getPrimaryToolbarLegacyComponent(_ref3) {
  var api = _ref3.api,
    editorPluginAIProvider = _ref3.editorPluginAIProvider,
    aiGlobalOptIn = _ref3.aiGlobalOptIn;
  return function (_ref4) {
    var editorView = _ref4.editorView;
    return /*#__PURE__*/React.createElement(PrimaryToolbarLegacyComponent, {
      api: api,
      editorView: editorView,
      editorPluginAIProvider: editorPluginAIProvider,
      aiGlobalOptIn: aiGlobalOptIn
    });
  };
};